import { requestSocialLogin, requestEmailLogin, emailLogin } from '../../api/authentication'
import {
  REQUEST_SOCIAL_LOGIN,
  SET_RESET_PASSWORD_PROMPT,
  REQUEST_EMAIL_LOGIN,
  EMAIL_LOGIN,
  SET_PASSWORD_ERROR,
  RESET_PASSWORD_ERROR,
  SET_FORGOT_EMAIL_LOGIN,
  FORGOT_EMAIL_LOGIN
} from './constant'
import {
  SocialLoginPayload,
  RequestEmailLoginPayload,
  EmailLoginPayload,
  RedirectResponse,
  Provider
} from '../../api/type'
import { ActionTree } from 'vuex'
import { AuthState } from './types'
import { Response } from '@/store/api/type'
import { FACEBOOK_SOCIAL } from '../../../constant/social'
import router from '../../../router'

import { SET_PROVIDERS, SET_PROFILE_PIC_URL, SET_EMAIL_ERROR, REGISTER_MODULE } from '../register/constant'

import { APP_MODULE, SET_IS_LOADING } from '../app/constant'

const regex = /^nterapp\/(\d.\d.\d) \(android\).*/g
export const unsupportedWebViewSocialLogin = (userAgent: string, social: string): boolean => {
  if (social == FACEBOOK_SOCIAL && userAgent.match(regex)) {
    return true
  }

  return false
}

export const supportedHybridSocialLogin = (userAgent: string, social: string): boolean => {
  const substring: string = 'hybrid-' + social
  return userAgent.indexOf(substring) >= 0
}

export const actions: ActionTree<AuthState, unknown> = {
  async [REQUEST_SOCIAL_LOGIN](_, payload: SocialLoginPayload) {
    const userAgent = navigator ? navigator.userAgent : ''
    if (supportedHybridSocialLogin(userAgent, payload.provider)) {
      router.push({ path: 'hybrid', query: { source: payload.provider } }).catch(() => {
        // disabled route warning
      })
      return
    }

    if (unsupportedWebViewSocialLogin(userAgent, payload.provider)) {
      router.push({ path: 'incident' }).catch(() => {
        // disabled route warning
      })
      return
    }

    try {
      const resp = await requestSocialLogin(payload)
      const data = resp as Response
      const redirectData = data.data as RedirectResponse
      location.replace(redirectData.redirect_to)
      return
    } catch (e) {
      return
    }
  },
  [SET_RESET_PASSWORD_PROMPT]({ commit }, resetPasswordPrompt: string) {
    commit(SET_RESET_PASSWORD_PROMPT, resetPasswordPrompt)
  },
  async [REQUEST_EMAIL_LOGIN]({ commit }, { email, challenge }) {
    const payload: RequestEmailLoginPayload = {
      email: email,
      challenge
    }
    commit(`${APP_MODULE}/${SET_IS_LOADING}`, true, { root: true })
    try {
      const resp = await requestEmailLogin(payload)
      const data = resp as Response
      const providers = data.data as Array<Provider>
      commit(`${REGISTER_MODULE}/${SET_PROVIDERS}`, providers, { root: true })
      if (providers.length > 0) {
        commit(`${REGISTER_MODULE}/${SET_PROFILE_PIC_URL}`, providers[0].profile_url, { root: true })
      }
      router.push({ path: 'email-login' })
      return
    } catch (e) {
      const errorResp = e as Response
      commit(`${REGISTER_MODULE}/${SET_EMAIL_ERROR}`, errorResp?.error_message, { root: true })
      commit(`${APP_MODULE}/${SET_IS_LOADING}`, false, { root: true })
      return
    }
  },
  async [EMAIL_LOGIN]({ commit }, { email, password, challenge }) {
    const payload: EmailLoginPayload = {
      email,
      password,
      challenge
    }
    commit(`${APP_MODULE}/${SET_IS_LOADING}`, true, { root: true })
    try {
      const resp = await emailLogin(payload)
      const data = resp as Response
      const redirectData = data.data as RedirectResponse
      location.replace(redirectData.redirect_to)
      return
    } catch (e) {
      const errorResp = e as Response
      commit(SET_PASSWORD_ERROR, errorResp?.error_message)
      commit(`${APP_MODULE}/${SET_IS_LOADING}`, false, { root: true })
      return
    }
  },
  [SET_FORGOT_EMAIL_LOGIN]({ commit }, email: string) {
    commit(SET_FORGOT_EMAIL_LOGIN, email)
  },
  [SET_RESET_PASSWORD_PROMPT]({ commit }, resetPasswordPrompt: string) {
    commit(SET_RESET_PASSWORD_PROMPT, resetPasswordPrompt)
  },
  [RESET_PASSWORD_ERROR]({ commit }) {
    commit(SET_PASSWORD_ERROR, '')
  }
}
